<template>
  <section
    :class="{
      'section-builder-whats-new': true,
    }"
  >
    <GeneralTheme :theme="configuration">
      <div
        :class="{
          'container mx-auto': true,
        }"
      >
        <div
          :class="{
            'flex justify-center text-center': true,
          }"
        >
          <PortableText
            v-if="whatsNew?.heading?.standardPortableText"
            :portable-data="whatsNew.heading.standardPortableText"
            :class="{
              'mb-7 text-www-color-neutral-medium-dark': true,
            }"
          />
        </div>

        <WhatsNew />
      </div>
    </GeneralTheme>
  </section>
</template>

<script lang="ts" setup>
import PortableText from '~/components/Atmos/PortableText/PortableText.vue';
import GeneralTheme from '~/components/Molecules/Themes/GeneralTheme.vue';
import type { SectionBuilderWhatsNew } from '~/sanity/types';
import WhatsNew from './WhatsNew.vue';

defineProps<SectionBuilderWhatsNew>();
</script>
